import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDetailIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 17,
	viewBox: "0 0 15 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.76751 15.164C4.68431 15.0622 4.56109 15 4.42966 15H1.77778C1.34822 15 1 14.6518 1 14.2222V1.77778C1 1.34822 1.34822 1 1.77778 1H8.8606C9.02925 1 9.19334 1.05482 9.32812 1.15619L11.6897 2.93245C11.8851 3.07938 12 3.3096 12 3.55404V6.20976C12 6.36987 12.0886 6.51653 12.2253 6.59994C12.5464 6.79595 13 6.58089 13 6.20468V3.05489C13 2.81045 12.8851 2.58024 12.6897 2.43331L9.66221 0.156193C9.52743 0.0548183 9.36335 0 9.1947 0H1H0.777778C0.348223 0 0 0.348223 0 0.777778V1V15V15.2222C0 15.6518 0.348223 16 0.777778 16H1H4.42023C4.81639 16 5.0183 15.4706 4.76751 15.164ZM12.9347 15.9295C12.9064 15.9533 12.9235 16 12.9604 16C12.9822 16 13 15.982 13 15.9603C13 15.9267 12.9604 15.9079 12.9347 15.9295Z",
			fill: "#1E63FF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.0635,
			cy: 10.3546,
			r: 4.08932,
			stroke: "#1E63FF",
			strokeWidth: 1.01111
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3513 16.3574C13.5488 16.5549 13.8689 16.5549 14.0663 16.3574C14.2637 16.16 14.2637 15.8399 14.0663 15.6425L13.3513 16.3574ZM10.7913 13.7974L13.3513 16.3574L14.0663 15.6425L11.5063 13.0825L10.7913 13.7974Z",
			fill: "#1E63FF"
		})
	]
});
export default SvgDetailIcon;
